export default __webpack_public_path__ + "static/media/image48.ff4aa24a.png";